"use strict";
// This file was automatically generated by the Evolution Generator.
// The Evolution Generator is used to automate the creation of consistent, reliable code.
// Any changes made to this file will be overwritten.
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.workPlaceBeforeLeaveTypeChoices = exports.educationalAttainment = exports.noSchoolTripReasonChoices = exports.noWorkTripReasonChoices = exports.onDemandChoices = exports.onTheRoadArrivalTypeChoices = exports.departurePlaceOtherChoices = exports.householdOwnershipChoices = exports.householdIncomeChoices = exports.longDistanceFrequencyChoices = exports.schoolPlaceTypeChoices = exports.workPlaceTypeChoices = exports.transitFareType = exports.personOccupation = exports.schoolType = exports.participationStatusStudent = exports.participationStatusWorker = exports.maleFemaleCustomPreferNotToAnswer = exports.maleFemalePreferNotAnswer = exports.yesNoPreferNotToAnswer = exports.yesNoDontKnow = exports.yesNo = exports.preferNotToAnswer = exports.dontKnow = exports.otherWithoutSpecify = exports.other = exports.no = exports.yes = void 0;
const conditionals = __importStar(require("./conditionals"));
const customConditionals = __importStar(require("./customConditionals"));
exports.yes = [
    {
        value: 'yes',
        label: {
            fr: 'Oui',
            en: 'Yes'
        }
    }
];
exports.no = [
    {
        value: 'no',
        label: {
            fr: 'Non',
            en: 'No'
        }
    }
];
exports.other = [
    {
        value: 'other',
        label: {
            fr: 'Autre (spécifiez)',
            en: 'Other (specify)'
        }
    }
];
exports.otherWithoutSpecify = [
    {
        value: 'other',
        label: {
            fr: 'Autre',
            en: 'Other'
        }
    }
];
exports.dontKnow = [
    {
        value: 'dontKnow',
        label: {
            fr: 'Je ne sais pas',
            en: 'I don\'t know'
        }
    }
];
exports.preferNotToAnswer = [
    {
        value: 'preferNotToAnswer',
        label: {
            fr: 'Je préfère ne pas répondre',
            en: 'I prefer not to answer'
        }
    }
];
exports.yesNo = [...exports.yes, ...exports.no];
exports.yesNoDontKnow = [...exports.yesNo, ...exports.dontKnow];
exports.yesNoPreferNotToAnswer = [...exports.yes, ...exports.no, ...exports.preferNotToAnswer];
exports.maleFemalePreferNotAnswer = [
    {
        value: 'female',
        label: {
            fr: 'Femme',
            en: 'Female'
        }
    },
    {
        value: 'male',
        label: {
            fr: 'Homme',
            en: 'Male'
        }
    },
    ...exports.preferNotToAnswer
];
exports.maleFemaleCustomPreferNotToAnswer = [
    {
        value: 'female',
        label: {
            fr: 'Femme',
            en: 'Woman'
        }
    },
    {
        value: 'male',
        label: {
            fr: 'Homme',
            en: 'Man'
        }
    },
    {
        value: 'custom',
        label: {
            fr: 'Cette personne s\'identifie comme:',
            en: 'This person identifies  as:'
        }
    },
    ...exports.preferNotToAnswer
];
exports.participationStatusWorker = [
    {
        value: 'fullTime',
        label: {
            fr: 'Oui, à temps plein (30h et plus/semaine)',
            en: 'Yes, full time (30h and more/week)'
        }
    },
    {
        value: 'partTime',
        label: {
            fr: 'Oui, à temps partiel (moins de 30h/semaine)',
            en: 'Yes, part time (less than 30h/week)'
        }
    },
    ...exports.no
];
exports.participationStatusStudent = [
    {
        value: 'fullTime',
        label: {
            fr: 'Oui, à temps plein',
            en: 'Yes, full time'
        }
    },
    {
        value: 'partTime',
        label: {
            fr: 'Oui, à temps partiel',
            en: 'Yes, part time'
        }
    },
    ...exports.no
];
exports.schoolType = [
    {
        value: 'kindergarten',
        label: {
            fr: 'Garderie/CPE',
            en: 'Kindergarten/Childcare/CPE'
        },
        conditional: conditionals.ifAge5OrLessConditional
    },
    {
        value: 'primarySchool',
        label: {
            fr: 'École primaire',
            en: 'Primary school'
        },
        conditional: conditionals.ifAge4to13Conditional
    },
    {
        value: 'secondarySchool',
        label: {
            fr: 'École secondaire',
            en: 'Secondary school'
        },
        conditional: conditionals.ifAge11OrMoreConditional
    },
    {
        value: 'schoolAtHome',
        label: {
            fr: 'École à la maison',
            en: 'School at home'
        },
        conditional: conditionals.ifAge4to15Conditional
    },
    {
        value: 'atHome',
        label: {
            fr: 'À la maison',
            en: 'At home'
        },
        conditional: conditionals.ifAge5OrLessConditional
    },
    {
        value: 'collegeCegepDepAep',
        label: {
            fr: 'CEGEP / Collège / DEP / AEP',
            en: 'CEGEP / College / DEP / AEP'
        },
        conditional: conditionals.ifAge15OrMoreConditional
    },
    ...exports.other
];
exports.personOccupation = [
    {
        value: 'fullTimeWorker',
        label: {
            fr: 'Travail à temps plein (30h et plus/semaine)',
            en: 'Employed full-time (30h and more/week)'
        },
        hidden: true
    },
    {
        value: 'partTimeWorker',
        label: {
            fr: 'Travail à temps partiel (moins de 30h/semaine)',
            en: 'Employed part-time (less than 30h/week)'
        },
        hidden: true
    },
    {
        value: 'workerAndStudent',
        label: {
            fr: 'Travail et études',
            en: 'Work and studies'
        },
        hidden: true
    },
    {
        value: 'fullTimeStudent',
        label: {
            fr: 'Études à temps plein',
            en: 'Full-time student'
        },
        hidden: true
    },
    {
        value: 'partTimeStudent',
        label: {
            fr: 'Études à temps partiel',
            en: 'Part-time student'
        },
        hidden: true
    },
    {
        value: 'retired',
        label: {
            fr: 'À la retraite',
            en: 'Retired'
        },
        conditional: conditionals.ifAge40OrMoreConditional
    },
    {
        value: 'atHome',
        label: {
            fr: 'À la maison',
            en: 'At home'
        }
    },
    {
        value: 'unemployed',
        label: {
            fr: 'En chômage / en recherche d\'emploi',
            en: 'Unemployed / searching for a job'
        }
    },
    {
        value: 'parentalOrSickLeave',
        label: {
            fr: 'Congé de maladie ou congé parental',
            en: 'Sick leave or parental leave'
        }
    },
    {
        value: 'longTermDisability',
        label: {
            fr: 'Invalidité de longue durée',
            en: 'Long-term disability'
        }
    },
    {
        value: 'volunteer',
        label: {
            fr: 'Bénévole',
            en: 'Volunteer'
        }
    },
    {
        value: 'other',
        label: {
            fr: 'Autre',
            en: 'Other'
        }
    },
    {
        value: 'preferNotToAnswer',
        label: {
            fr: 'Préfère ne pas répondre',
            en: 'Prefer not to answer'
        }
    }
];
exports.transitFareType = [
    ...exports.no,
    {
        value: 'transitPass',
        label: {
            fr: 'Passe ou titre mensuel ou annuel',
            en: 'Monthly or annual pass'
        }
    },
    {
        value: 'tickets',
        label: {
            fr: 'Titres ou billets individuels',
            en: 'Individual tickets or rides'
        }
    },
    ...exports.dontKnow
];
exports.workPlaceTypeChoices = [
    {
        value: 'onLocation',
        label: {
            fr: 'Oui, travail au lieu fixe en présentiel en tout temps',
            en: 'Yes, always on-site at fixed location'
        }
    },
    {
        value: 'hybrid',
        label: {
            fr: 'Oui, travail en mode hybride (télétravail et en présentiel)',
            en: 'Yes, hybrid work (remote and on-site)'
        }
    },
    {
        value: 'onTheRoadWithUsualPlace',
        label: {
            fr: 'Oui, travail sur la route avec départ d\'un lieu fixe (ex: garage, bureau, poste, restaurant, etc.)',
            en: 'Yes, work on the road departing from a fixed location (ex: garage, office, station, restaurant, etc.)'
        }
    },
    {
        value: 'onTheRoadWithoutUsualPlace',
        label: {
            fr: 'Non, travail sur la route avec départ du domicile',
            en: 'No, work on the road departing from home'
        }
    },
    {
        value: 'remote',
        label: {
            fr: 'Non, travail à partir du domicile ou à distance',
            en: 'No, work from home or from elsewhere'
        }
    }
];
exports.schoolPlaceTypeChoices = [
    {
        value: 'onLocation',
        label: {
            fr: 'Oui, études au lieu fixe en présentiel en tout temps',
            en: 'Yes, always on-site at fixed location'
        }
    },
    {
        value: 'hybrid',
        label: {
            fr: 'Oui, études en mode hybride (télé-études et en présentiel)',
            en: 'Yes, hybrid studies (remote and on-site)'
        }
    },
    {
        value: 'remote',
        label: {
            fr: 'Non, études à partir du domicile ou à distance',
            en: 'No, remote studies from home or from elsewhere'
        }
    }
];
exports.longDistanceFrequencyChoices = [
    {
        value: '00_00',
        label: {
            fr: 'Jamais (0)',
            en: 'Never (0)'
        }
    },
    {
        value: '01_03',
        label: {
            fr: 'Quelques fois durant la période (1 à 3)',
            en: 'A few times during the period (1 to 3)'
        }
    },
    {
        value: '04_12',
        label: {
            fr: 'Quelques fois par mois (4 à 12)',
            en: 'A few times a month (4 to 12)'
        }
    },
    {
        value: '13_99',
        label: {
            fr: 'Une à plusieurs fois par semaine (13 ou plus)',
            en: 'One to several times a week (13 or more)'
        }
    }
];
exports.householdIncomeChoices = [
    {
        value: '000000_009999',
        label: {
            fr: 'Moins de 10 000 $',
            en: 'Less than $10,000'
        }
    },
    {
        value: '010000_019999',
        label: {
            fr: '10 000$ à 19 999$',
            en: '$10,000 to $19,999'
        }
    },
    {
        value: '020000_029999',
        label: {
            fr: '20 000$ à 29 999$',
            en: '$20,000 to $29,999'
        }
    },
    {
        value: '030000_039999',
        label: {
            fr: '30 000$ à 39 999$',
            en: '$30,000 to $39,999'
        }
    },
    {
        value: '040000_049999',
        label: {
            fr: '40 000$ à 49 999$',
            en: '$40,000 to $49,999'
        }
    },
    {
        value: '050000_059999',
        label: {
            fr: '50 000$ à 59 999$',
            en: '$50,000 to $59,999'
        }
    },
    {
        value: '060000_069999',
        label: {
            fr: '60 000$ à 69 999$',
            en: '$60,000 to $69,999'
        }
    },
    {
        value: '070000_079999',
        label: {
            fr: '70 000$ à 79 999$',
            en: '$70,000 to $79,999'
        }
    },
    {
        value: '080000_089999',
        label: {
            fr: '80 000$ à 89 999$',
            en: '$80,000 to $89,999'
        }
    },
    {
        value: '090000_099999',
        label: {
            fr: '90 000$ à 99 999$',
            en: '$90,000 to $99,999'
        }
    },
    {
        value: '100000_149999',
        label: {
            fr: '100 000$ à 149 999$',
            en: '$100,000 to $149,999'
        }
    },
    {
        value: '150000_199999',
        label: {
            fr: '150 000$ à 199 999$',
            en: '$150,000 to $199,999'
        }
    },
    {
        value: '200000_999999',
        label: {
            fr: '200 000 $ et plus',
            en: '$200,000 and more'
        }
    },
    {
        value: 'dontKnow',
        label: {
            fr: 'Je ne sais pas',
            en: 'I don\'t know'
        }
    },
    {
        value: 'refusal',
        label: {
            fr: 'Je préfère ne pas répondre',
            en: 'I prefer not to respond'
        }
    }
];
exports.householdOwnershipChoices = [
    {
        value: 'tenant',
        label: {
            fr: 'Locataire',
            en: 'Tenant'
        }
    },
    {
        value: 'owner',
        label: {
            fr: 'Propriétaire',
            en: 'Owner'
        }
    },
    {
        value: 'other',
        label: {
            fr: 'Autre',
            en: 'Other'
        }
    },
    {
        value: 'preferNotToAnswer',
        label: {
            fr: 'Je préfère ne pas répondre',
            en: 'I prefer not to respond'
        }
    }
];
exports.departurePlaceOtherChoices = [
    {
        value: 'otherParentHome',
        label: {
            fr: '<strong>Domicile de l\'autre parent ou tuteur</strong>',
            en: '<strong>Home of the other parent or guardian</strong>'
        },
        conditional: conditionals.ifAge16OrLessConditional
    },
    {
        value: 'workedOvernight',
        label: {
            fr: '<strong>Travaillait de nuit</strong>',
            en: '<strong>Worked overnight</strong>'
        },
        conditional: conditionals.isWorkerConditional
    },
    {
        value: 'secondaryHome',
        label: {
            fr: '<strong>Résidence secondaire</strong> (chalet ou autre)',
            en: '<strong>Secondary residence</strong> (cottage or other)'
        }
    },
    {
        value: 'sleptAtFriends',
        label: {
            fr: 'Passait la nuit chez <strong>ami, copine/copain ou famille</strong>',
            en: 'Stayed at a <strong>friend’s, partner’s or family’s home</strong>'
        }
    },
    {
        value: 'restaurant',
        label: {
            fr: 'Était à un ou revenait d\'un <strong>restaurant ou bar</strong>',
            en: 'Was at or was coming back from a <strong>restaurant or bar</strong>'
        }
    },
    {
        value: 'hotelForWork',
        label: {
            fr: 'Hôtel ou autre lieu pour une <strong>conférence / travail</strong>',
            en: 'Hotel or other venue for <strong>a conference / work</strong>'
        },
        conditional: conditionals.isWorkerConditional
    },
    {
        value: 'hotelForVacation',
        label: {
            fr: 'Hôtel ou autre lieu en <strong>vacances</strong>',
            en: 'Hôtel or other on <strong>vacation</strong>'
        }
    },
    {
        value: 'studying',
        label: {
            fr: '<strong>Écoles / lieu d’études</strong>: terminait des travaux ou y couchait',
            en: '<strong>School / place of study</strong>: studied or slept there'
        },
        conditional: conditionals.isStudentConditional
    },
    {
        value: 'other',
        label: {
            fr: 'Autre',
            en: 'Other'
        }
    }
];
exports.onTheRoadArrivalTypeChoices = [
    {
        value: 'home',
        label: {
            fr: 'Domicile',
            en: 'Home'
        }
    },
    {
        value: 'usualWorkPlace',
        label: {
            fr: 'Lieu de travail habituel',
            en: 'Usual work place'
        },
        conditional: conditionals.onTheRoadUsualWorkplace
    },
    {
        value: 'other',
        label: {
            fr: 'Autre lieu',
            en: 'Other location'
        }
    },
    {
        value: 'stayedThereUntilTheNextDay',
        label: {
            fr: '{{nickname}} a complété ses déplacements sur la route après 4:00 du matin le lendemain',
            en: '{{nickname}} completed {{gender:his/her/their/their}} work on the road trips after 4AM the next day'
        },
        conditional: customConditionals.isLastPlaceCustomConditional
    }
];
exports.onDemandChoices = [
    {
        value: 'pickupAtOrigin',
        label: {
            fr: 'Oui, il est venu chercher {{nickname}} à son lieu de départ',
            en: 'Yes, it picked {{nickname}} up at their departure location'
        }
    },
    {
        value: 'joinedStop',
        label: {
            fr: 'Oui, {{nickname}} a rejoint un arrêt',
            en: 'Yes, {{nickname}} went to a stop'
        }
    },
    {
        value: 'no',
        label: {
            fr: 'Non',
            en: 'No'
        }
    }
];
exports.noWorkTripReasonChoices = [
    {
        value: 'remoteWorkOrWorkAtHome',
        label: {
            fr: 'Télétravail / travail à la maison',
            en: 'Remote work / work from home'
        }
    },
    {
        value: 'onStrike',
        label: {
            fr: 'En grève',
            en: 'On strike'
        }
    },
    {
        value: 'leaveSicknessPersonalReason',
        label: {
            fr: 'Congé (maladie, personnel, autre)',
            en: 'Leave (sick, personal, other)'
        }
    },
    {
        value: 'noWork',
        label: {
            fr: 'Pas de travail prévu',
            en: 'No work planned'
        }
    },
    ...exports.otherWithoutSpecify,
    ...exports.dontKnow
];
exports.noSchoolTripReasonChoices = [
    {
        value: 'distanceLearning',
        label: {
            fr: 'Cours à distance',
            en: 'Distance learning'
        }
    },
    {
        value: 'schoolWasClosed',
        label: {
            fr: 'École fermée',
            en: 'School was closed'
        }
    },
    {
        value: 'leaveSicknessPersonalReason',
        label: {
            fr: 'Congé (maladie, personnel, autre)',
            en: 'Leave (sick, personal, other)'
        }
    },
    {
        value: 'noSchool',
        label: {
            fr: 'Pas de cours',
            en: 'No classes'
        }
    },
    ...exports.otherWithoutSpecify,
    ...exports.dontKnow
];
exports.educationalAttainment = [
    {
        value: 'noneOrPrimaryEducation',
        label: {
            fr: 'Aucun certificat, diplôme ou degré',
            en: 'No certificate, diploma or degree'
        }
    },
    {
        value: 'secondaryEducation',
        label: {
            fr: 'Diplôme d\'études secondaires ou attestation d\'équivalence',
            en: 'High school (secondary) diploma or equivalency certificate'
        }
    },
    {
        value: 'postSecondaryNonTertiaryEducation',
        label: {
            fr: 'Diplôme d\'apprenti ou d\'une école de métiers',
            en: 'Apprenticeship or trades certificate or diploma'
        }
    },
    {
        value: 'shortCycleTertiaryEducation',
        label: {
            fr: 'Diplôme d\'un cégep ou collège',
            en: 'College, CEGEP or other non-university certificate or diploma'
        }
    },
    {
        value: 'diplomaBelowBachelor',
        label: {
            fr: 'Certificat ou diplôme universitaire inférieur au baccalauréat',
            en: 'University certificate or diploma below bachelor level'
        }
    },
    {
        value: 'bachelorOrHigher',
        label: {
            fr: 'Certificat ou diplôme universitaire niveau baccalauréat ou supérieur',
            en: 'Bachelor\'s degree or higher'
        }
    },
    ...exports.preferNotToAnswer
];
exports.workPlaceBeforeLeaveTypeChoices = [
    {
        value: 'onLocation',
        label: {
            fr: 'Oui, {{nickname}} travaillait au lieu fixe en présentiel en tout temps',
            en: 'Yes, {{nickname}} worked always on-site at fixed location'
        }
    },
    {
        value: 'hybrid',
        label: {
            fr: 'Oui, {{nickname}} travaillait en mode hybride (télétravail et en présentiel)',
            en: 'Yes, {{nickname}} did hybrid work (remote and on-site)'
        }
    },
    {
        value: 'onTheRoadWithUsualPlace',
        label: {
            fr: 'Oui, {{nickname}} travaillait sur la route avec départ d\'un lieu fixe (ex: garage, bureau, poste, restaurant, etc.)',
            en: 'Yes, {{nickname}} worked on the road departing from a fixed location (ex: garage, office, station, restaurant, etc.)'
        }
    },
    {
        value: 'onTheRoadWithoutUsualPlace',
        label: {
            fr: 'Non, {{nickname}} travaillait sur la route avec départ du domicile',
            en: 'No, {{nickname}} worked on the road departing from home'
        }
    },
    {
        value: 'remote',
        label: {
            fr: 'Non, {{nickname}} travaillait à partir du domicile ou à distance',
            en: 'No, {{nickname}} worked from home or from elsewhere'
        }
    }
];
